import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { BootstrapAlert } from "../../components/BootstrapAlert/index.js";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";

// services
import {
  useGetTrainingMenuBasedOnModuleQuery,
  useBookmarkModuleMutation,
  useUpdateModuleStatusMutation,
} from "../../store/services/moduleServerApi";

const Module_1_0 = () => {
  const { pathname: pathName } = useLocation();
  const navigate = useNavigate();

  const { menuItems } = useSelector((state) => state?.moduleSlice);

  /* Start useState */
  const [skipGetTrainingMenu, setSkipGetTrainingMenu] = useState(false);

  /* End useState */

  const { isLoading: isMenuFetched } = useGetTrainingMenuBasedOnModuleQuery(1, {
    skip: skipGetTrainingMenu,
  });

  const [
    updateModuleStatus,
    {
      isLoading,
      status: updateStatus,
      error: { data: { message: errorMessage } = {} } = {},
    },
  ] = useUpdateModuleStatusMutation();

  const [bookmarkModule, { status: bookmarkStatus }] =
    useBookmarkModuleMutation();

  if (bookmarkStatus === "fulfilled") {
    navigate("/module-1/indications");
  }

  /* Start useEffect */
  useEffect(() => {
    if (updateStatus === "fulfilled") {
      bookmarkModule({ pathName });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateStatus]); // * onUpdateMenu Status
  /* End useEffect */

  /* Start custom function */
  const handleStartModuleOne = () => {
    setSkipGetTrainingMenu(true);
    updateModuleStatus({ moduleNo: 1, start: 1 });
  };

  return (
    <div className="row">
      {isMenuFetched && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}

      <div className="col-sm-8">
        <main className="module-content">
          <h1 className="blue text-uppercase b mt-5 mb-4">MODULE 1 OVERVIEW</h1>
          <p className="d-inline me-4 b">30 Minutes</p>
          <p className="d-inline me-4 b">English</p>
          <p className="d-inline me-4 b">MIM Referring Required</p>
          <h2 className="b text-uppercase mt-4">
            <span className="orange">
              Learn about Alzheimer's disease (AD),
            </span>
            <br /> its underlying neuropathology, and the role of Amyvid
          </h2>
          <article className="mt-5">
            <h3 className="b mb-3">In this module</h3>
            <ul>
              <li>Indication and Limitations of Use</li>
              <li>Important Safety Information</li>
              <li>Chapter 1: Overview of AD and its neuropathology</li>
              <li>Chapter 2: Amyvid for β-amyloid plaque PET imaging</li>
              <li>Chapter 3: Amyvid clinical trials</li>
              <li>Chapter 4: How to use Amyvid</li>
            </ul>
          </article>
          <article className="mt-5 mb-5">
            <h3 className="b mb-3">Key learning</h3>
            <ul>
              <li>
                Review the key characteristics of AD, its neuropathology, and
                the challenge of diagnosis
              </li>
              <li>Illustrate the mechanism of action of Amyvid</li>
              <li>
                Describe the results of the 3 pivotal clinical trials that
                demonstrated the reliability, accuracy, and reproducibility of
                Amyvid
              </li>
              <li>Discuss dosing and administration for Amyvid</li>
            </ul>
          </article>
          <section className="button-control">
            <BootstrapAlert variant="danger" message={errorMessage} />

            <LdsButton
              className="blue-button mt-3 mb-5 next"
              disabled={isLoading}
              onClick={handleStartModuleOne}
            >
              Start Module 1
            </LdsButton>
          </section>
        </main>
      </div>
    </div>
  );
};

export default Module_1_0;
